module.exports = {
      id: "refresh-icon-usage",
      viewBox: "0 0 18 18",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#refresh-icon",
      toString: function () {
        return this.url;
      }
    }